module.exports = __webpack_public_path__ + "assets/img/e49b-hm.svg";